// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3sBTs","header":"PatientBlock_header__Y5asE","label":"PatientBlock_label__b1b01","option":"PatientBlock_option__1jHpr"};